<template>
    <div class="chat-user-item">
        <div class="chat-user-profile">
            <img :src="img" v-if="img">
            <div class="chat-user-profile__initials" :style="{background: color}" v-else>
                {{ initials }}
            </div>
        </div>
        <div class="chat-user-info">
            <div class="chat-user-info__name">
                {{ fullName }}
            </div>
            <div class="chat-user-info__work" v-if="workInfo">
                {{ workInfo }}
            </div>
        </div>
    </div>
</template>

<script>
    import Profile from "../../models/Users/Profile";

    export default {
        name: "User",
        props: {
            user: {
                type: Profile,
                required: true
            }
        },
        computed: {
            img() {
                return this.user.photoUrl(this.$store.state.session);
            },
            color() {
                return this.user.color();
            },
            initials() {
                return this.user.initials();
            },
            fullName() {
                return this.user.fullName();
            },
            workInfo() {
                return this.user.workInfo();
            }
        }
    }
</script>

<style scoped>

</style>